import { render, staticRenderFns } from "./DoctorTable.vue?vue&type=template&id=7aae7f57&"
import script from "./DoctorTable.vue?vue&type=script&lang=js&"
export * from "./DoctorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports